import React, { useState, useEffect, useMemo } from 'react';
const roboman_api = process.env.REACT_APP_ROBOMAN_API;

// --- ICONS (for a real app, use an icon library or SVGs) ---
const SearchIcon = ({ className }) => (
    <svg xmlns="http://www.w.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
);
const PlusIcon = ({ className }) => (
    <svg xmlns="http://www.w.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
);
const MoreHorizontalIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
);

// --- MOCK DATA ---
const initialMembers = [
    // { id: 1, name: 'Alex Johnson', email: 'alex@example.com', role: 'Admin', avatar: 'https://placehold.co/40x40/E2E8F0/475569?text=AJ', lastActive: 'Online now' },
    // { id: 2, name: 'Sara Miller', email: 'sara@example.com', role: 'Member', avatar: 'https://placehold.co/40x40/FBCFE8/9D27B0?text=SM', lastActive: 'Active 2 hours ago' },
    // { id: 3, name: 'Raj Patel', email: 'raj@example.com', role: 'Member', avatar: 'https://placehold.co/40x40/FEE2E2/B91C1C?text=RP', lastActive: 'Active yesterday' },
    // { id: 4, name: 'Emily Chen', email: 'emily.chen@work.co', role: 'Admin', avatar: 'https://placehold.co/40x40/D1FAE5/047857?text=EC', lastActive: 'Active 3 days ago' },
    // { id: 5, name: 'david.lee@invited.com', email: 'david.lee@invited.com', role: 'Pending', avatar: null, lastActive: 'Invitation sent' },
];

// --- UI COMPONENTS ---
const SectionCard = ({ children, title, subtitle }) => (
    <div className="p-4 sm:p-8 min-h-screen">
        <div className='max-w-4xl mx-auto' >
            <h2 className="text-xl md:text-2xl font-extrabold font-Inter opacity-1 bg-gradient-to-r from-gray-700 via-blue-700 to-fuchsia-700  bg-clip-text text-transparent">{title}</h2>
            <p className="mt-1 text-sm text-slate-600">{subtitle}</p>
            <div className="mt-6">{children}</div>
        </div>
    </div>
);
const Card = ({ children, className }) => (
    <div className={`bg-white/70 backdrop-blur-sm p-0 rounded-2xl shadow-lg border border-white/50 overflow-hidden ${className}`}>
        {children}
    </div>
);
const Avatar = ({ member }) => {
    if (member.avatar) {
        return <img className="w-10 h-10 rounded-full " src={member.avatar} alt={member.name} onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/40x40/E2E8F0/475569?text=??'; }} />;
    }
    const initials = member.name.split(' ').map(n => n[0]).join('').substring(0, 2);
    return (
        <div className="w-20 h-20 rounded-full bg-slate-200 text-slate-900  flex items-center text-2xl justify-center">
            {member.role === 'Pending' ? '?' : initials}
        </div>
    );
};
const LoadingCards = () => (
    <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 p-2 md:p-4">
        {[1,2,3].map(i => (
            <div key={i} className="bg-white rounded-2xl shadow-md border border-slate-200 p-4 sm:p-6 flex flex-col items-center text-center min-h-[200px] sm:min-h-[240px] w-full animate-pulse">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-slate-200 rounded-full mb-3 sm:mb-4"></div>
                <div className="h-4 bg-slate-200 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-slate-200 rounded w-1/2"></div>
            </div>
        ))}
    </div>
);

const Members = () => {
    const [members, setMembers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [newInviteEmail, setNewInviteEmail] = useState('');
    const [isSendingInvite, setIsSendingInvite] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    //******** 

    const fetchmembers = async () => {
        setIsLoading(true);
        try {
            // console.log("api is : " + roboman_api)
            const accessToken = localStorage.getItem("access_token")
            const response = await fetch(`${roboman_api}/users/me`, {
                method: 'GET',
                headers: {
                    accept: 'application/json',
                    Authorization: accessToken
                }

            })
            if (!response.ok) {
                throw new Error('Failed to fetch user');
            }

            const data = await response.json()
            // console.log(data)
            const member = mapApiUserToMember(data);
            setMembers([member]);
        }
        catch (error) {
            console.error('Error:', error);
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchmembers();
    }, [])

    const mapApiUserToMember = (user) => ({
        id: user.user_id,
        name: user.user_info?.nick_name || user.email,
        email: user.email,
        role: 'Admin',          // default role
        avatar: null,
        lastActive: 'Online'
    });



    const filteredMembers = useMemo(() => {
        return members.filter(member =>
            member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            member.email.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [searchTerm, members]);

    const handleInvite = (e) => {
        e.preventDefault();
        if (!newInviteEmail) return;

        setIsSendingInvite(true);
        setTimeout(() => {
            const newMember = {
                id: Date.now(),
                name: newInviteEmail,
                email: newInviteEmail,
                role: 'Pending',
                avatar: null,
                lastActive: 'Invitation sent'
            };
            setMembers([newMember, ...members]);
            setNewInviteEmail('');
            setIsSendingInvite(false);
        }, 1000);
    };

    return (
        <SectionCard title="Members" subtitle="Manage your team members and their permissions.">
            <Card>
                {/* Header and Invite Form */}
                <div className="p-6 border-b border-slate-200 space-y-4">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                        <div className="relative w-full sm:w-72">
                            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                            <input
                                type="text"
                                placeholder="Search members..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 bg-white border border-slate-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                    </div>
                    <form onSubmit={handleInvite} className="flex flex-col sm:flex-row gap-2">
                        <input
                            type="email"
                            placeholder="new.member@example.com"
                            value={newInviteEmail}
                            onChange={(e) => setNewInviteEmail(e.target.value)}
                            className="flex-grow px-4 py-2 bg-white border border-slate-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                        <button type="submit" disabled={isSendingInvite} className="bg-gradient-to-r from-indigo-600 via-violet-600 to-pink-600 text-white font-semibold py-2 px-5 rounded-lg hover:bg-blue-700 transition-colors shadow-md flex items-center justify-center gap-2 disabled:bg-slate-400">
                            <PlusIcon className="w-5 h-5" />
                            {isSendingInvite ? 'Sending...' : 'Send Invite'}
                        </button>
                    </form>
                </div>


                {/* member list */}
                {isLoading ?
                    (<LoadingCards />) :
                    (filteredMembers.length === 0 ? (
                            <div className="col-span-full text-center py-12 sm:py-16">
                                <div className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-slate-100 mb-3 sm:mb-4">
                                    <svg className="w-6 h-6 sm:w-8 sm:h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                    </svg>
                                </div>
                                <p className="text-slate-500 font-medium text-sm sm:text-base">No members found</p>
                                <p className="text-slate-400 text-xs sm:text-sm mt-1">Try adjusting your filters</p>
                            </div>
                        ): (<div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 p-2 md:p-4">
                                {filteredMembers.map(member => (
                                    <div
                                        key={member.id}
                                        className="group relative bg-gradient-to-br from-white rounded-2xl shadow-md border border-slate-200 p-4 sm:p-6 flex flex-col items-center text-center hover:shadow-xl transition-all duration-300 min-h-[200px] sm:min-h-[240px] w-full overflow-hidden"
                                    >
                                        {/* Decorative gradient overlay */}
                                        <div className="absolute top-0 left-0 right-0 h-16 sm:h-20 bg-gradient-to-r from-fuchsia-100 via-voilet-100 to-violet-700/10 -z-0"></div>

                                        {/* Avatar with ring effect */}
                                        <div className="relative mb-3 sm:mb-4 z-10">
                                            <div className="absolute rounded-full blur-md opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
                                            <Avatar
                                                member={member}
                                                className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-full ring-2 sm:ring-4 ring-white shadow-lg"
                                            />
                                        </div>

                                        {/* Name */}
                                        <h3 className="font-semibold text-base sm:text-lg text-slate-900 mb-1 sm:mb-2 group-hover:text-indigo-600 transition-colors duration-300 px-2 break-words w-full">
                                            {member.name}
                                        </h3>

                                        {/* Email with icon */}
                                        <div className="flex items-center gap-1.5 sm:gap-2 text-slate-600 mb-2 px-2 w-full justify-center">
                                            <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-slate-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                            <span className="text-xs sm:text-sm text-slate-500 truncate max-w-[calc(100%-2rem)]">
                                                {member.email}
                                            </span>
                                        </div>
                                    </div>
                                ))}



                                {/* {filteredMembers.length === 0 && (
                        <div className="col-span-full text-center py-12 sm:py-16">
                            <div className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-slate-100 mb-3 sm:mb-4">
                                <svg className="w-6 h-6 sm:w-8 sm:h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            </div>
                            <p className="text-slate-500 font-medium text-sm sm:text-base">No members found</p>
                            <p className="text-slate-400 text-xs sm:text-sm mt-1">Try adjusting your filters</p>
                        </div>
                    )} */}

                            </div>))}
                
            </Card>
        </SectionCard>
    );
};

export default Members;
